module.exports = __webpack_public_path__ + "img/out_of_bounds.be9f068a.jpg";